import { toZonedTime } from 'date-fns-tz';

export function parseDate<T = Date | string>(value: Date | string): T {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const isUtc =
      typeof value === 'string'
        ? value.includes('Z') || /^(\d{4})-(\d{2})-(\d{2})/.test(value)
        : false;

    const finalDate = isUtc ? toZonedTime(value, timezone) : new Date(value);

    if (
      isNaN(finalDate.valueOf()) ||
      (typeof value === 'string' &&
        !(value as string).includes(
          (finalDate as Date).getFullYear().toString()
        ))
    ) {
      return value as unknown as T;
    }
    return finalDate as unknown as T;
  } catch {
    return value as unknown as T;
  }
}
